import { AddAwayTimeCreateOrEditDto, AddAwayTimeGetAllDto, AddTimeOffCommentsDto, AddTimeStatus, AwayTimeType, DayType, LeaveType, OrganizationUnitServiceProxy, ProjectType4, UserListDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AddAwayTimeServiceProxy, ProjectServiceProxy, ProjectGetAllDto } from './../../../../shared/service-proxies/service-proxies';
import { Injectable } from '@angular/core';
import { Leave } from '../models/leave.model';
import { Subject } from 'rxjs';
import { DateTime } from 'luxon';
import { AbpSessionService } from 'abp-ng2-module';

@Injectable({
    providedIn: 'root'
})
export class TimeOffService {

    // Leave array with respective colors
    leaves: Leave[] = [
        {
            id: 1,
            color: '#4AB7F7'
        },
        {

            id: 2,
            color: '#EFA130'
        },
        {
            id: 3,
            color: '#4E5AD5'
        },
        {

            id: 4,
            color: '#4AB7F7'
        },
        {
            id: 5,
            color: '#567480'
        },
        {
            id: 6,
            color: '#E93C29'
        },
        {
            id: 7,
            color: '#57B02B'
        },
        {
            id: 8,
            color: '#3A4F8D'
        },
        {
            id: 9,
            color: '#DB5AD7'
        },
        {
            id: 10,
            color: '#E4E4E4'
        },
        {
            id: 11,
            color: '#e7e7e7'
        }
    ];
    //added for view calender date range filter in mytimeoff tab
    stopEventPropogation(event: Event) {
        event.stopPropagation();
    }

    isApprover: boolean = false;

    FromApprovalsTab: boolean = false;
    filter = '';
    monthNames = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Encrypt / decrypt password
    objEncryptPassword = 'timeOff';

    onCalendarDataLoaded = new Subject<AddAwayTimeGetAllDto[]>();

    updateTeamTimeoffCount = new Subject<number>();

    constructor(
        private addAwayTimeServiceProxy: AddAwayTimeServiceProxy,
        private organizationUnitServiceProxy: OrganizationUnitServiceProxy,
        private projectServiceProxy: ProjectServiceProxy,
        private userServiceProxy: UserServiceProxy,
        private _abpSession: AbpSessionService,
    ) {
        this.getAllOrganizationUnits();
        this.getAllProjects();
        this.getAllEmployees();
    }

    emitCalendarData(data: AddAwayTimeGetAllDto[]) {
        this.onCalendarDataLoaded.next(data);
    }

    getCalendarData() {
        return this.onCalendarDataLoaded.asObservable();
    }

    getLeaves() {
        return this.leaves;
    }

    getLeaveForPerticularUser(userId: number) {
        return this.addAwayTimeServiceProxy.getUserLeaveData(userId);
    }

    getFilteredTimeOffDataForCalendar(filter: string, orgIdArray: number[], projectIdArray: number[], userIdArray: number[], locationId: number[]) {
        return this.addAwayTimeServiceProxy.getAllCalendarView(filter, orgIdArray, projectIdArray, userIdArray, locationId,true); //.pipe(tap(r => console.log(r)));
    }

    getAllTimeOffDataForCalendar(IsShowAll :boolean) {
        return this.addAwayTimeServiceProxy.getAllCalendarView('', [], [], [], [],IsShowAll); //pipe(tap(r => console.log(r)));
    }

    getFilteredTimeOffDataForCalendarLeaveAndHoliday(filter: string, orgIdArray: number[], projectIdArray: number[], userIdArray: number[], locationId: number[]) {
        return this.addAwayTimeServiceProxy.getCalendarViewLeaveHoliday(filter, orgIdArray, projectIdArray, userIdArray, locationId); //.pipe(tap(r => console.log(r)));
    }

    // new api added for calenders holiday data
    getCalendarViewLeaveHoliday() {
        return this.addAwayTimeServiceProxy.getCalendarViewLeaveHoliday('', [], [], [], []); //.pipe(tap(r => console.log(r)));
    }

    getUsersCalendar() {
        return this.addAwayTimeServiceProxy.getUsersCalendar('', [], [], [], []); //.pipe(tap(r => console.log(r)));
    }

    getUsersCalendarFilter(filter: string, orgIdArray: number[], projectIdArray: number[], userIdArray: number[], locationId: number[]) {
        return this.addAwayTimeServiceProxy.getUsersCalendar(filter, orgIdArray, projectIdArray, userIdArray, locationId);
    }

    getMyTimeOffDataForCalendar() {
        return this.addAwayTimeServiceProxy.getAllForMyTimeOff('', [], [], [], undefined, undefined, undefined); //.pipe(tap(r => console.log(r)));
    }

    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(
            `${date.year}-${date.month < 10 ? "0" + date.month : date.month}-${date.day < 10 ? "0" + date.day : date.day}T${date.hour < 10 ? "0" + date.hour : date.hour
            }:${date.minute < 10 ? "0" + date.minute : date.minute}:${date.second < 10 ? "0" + date.second : date.second}`
        );
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }
    //
    getTimeOffDataForProject(projectIdArray: number[]) {
        return this.addAwayTimeServiceProxy.getCalendarViewLeaveHoliday('', [], [], projectIdArray, []);
    }

    getAllOrganizationUnits() {
        return this.organizationUnitServiceProxy.getOrganizationUnits('');
    }

    setZeroTimeForLocalDate(date: Date): Date {

        date.setHours(0, 0, 0, 0);

        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);

    }

    getAllProjects() {
        return this.projectServiceProxy.dropdownProjectList(undefined, undefined, false);
    }
    getAllProjectsDetailList() {
        return this.projectServiceProxy.getAllProjects(ProjectType4.AllProjects, this.filter, false);
    }

    getAllEmployees() {
        return this.userServiceProxy.getUsers('', undefined, undefined, undefined, false, false, undefined, undefined, undefined, undefined);
    }

    createTimeOff(title: string, teams: ProjectGetAllDto[], members: UserListDto[], fromDate: Date, toDate: Date, selectedAwayTimeType: number, description: string, leaveType: LeaveType, dayType: DayType) {
        const addAwayTimeCreateOrEditDto = new AddAwayTimeCreateOrEditDto();

        addAwayTimeCreateOrEditDto.title = title;
        addAwayTimeCreateOrEditDto.fromDate = fromDate as any;
        addAwayTimeCreateOrEditDto.toDate = toDate as any;
        addAwayTimeCreateOrEditDto.description = description;
        addAwayTimeCreateOrEditDto.addTimeProject = teams;
        addAwayTimeCreateOrEditDto.addTimeTeams = members;
        addAwayTimeCreateOrEditDto.awayTimeType = selectedAwayTimeType;
        addAwayTimeCreateOrEditDto.addTimeStatus = AddTimeStatus.Pending;
        addAwayTimeCreateOrEditDto.leaveTypeInfo = leaveType;
        addAwayTimeCreateOrEditDto.dayTypeInfo = dayType;

        return this.addAwayTimeServiceProxy.createOrEdit(addAwayTimeCreateOrEditDto);
    }
    getNumberOfWorkingDays(fromDate: Date, toDate: Date) {
        return this.addAwayTimeServiceProxy.getWorkingDays(DateTime.fromJSDate(this.setZeroTimeForLocalDate(fromDate)), DateTime.fromJSDate(this.setZeroTimeForLocalDate(toDate)));

    }

    getTimeoffDataForDelete(timeoffId: number) {
        return this.addAwayTimeServiceProxy.deleteTimeOfById(timeoffId);

    }

    getTimeoffDataForEdit(timeoffId: number) {
        return this.addAwayTimeServiceProxy.getTimeoffById(timeoffId);
    }
    checkValidityForLeaves(awayTime: AddAwayTimeCreateOrEditDto,isAddleave:boolean) {
        return this.addAwayTimeServiceProxy.checkAwayTimeValidity(0,isAddleave, awayTime);

    }
    editTimeoffdata(id: number, title: string, teams: ProjectGetAllDto[], members: UserListDto[], fromDate: Date, toDate: Date, selectedAwayTimeType: number, description: string, leaveType: LeaveType, dayType: DayType) {
        const addAwayTimeCreateOrEditDto = new AddAwayTimeCreateOrEditDto();
        addAwayTimeCreateOrEditDto.id = id;

        addAwayTimeCreateOrEditDto.title = title;
        addAwayTimeCreateOrEditDto.fromDate = fromDate as any;
        addAwayTimeCreateOrEditDto.toDate = toDate as any;
        addAwayTimeCreateOrEditDto.description = description;
        addAwayTimeCreateOrEditDto.addTimeProject = teams;
        addAwayTimeCreateOrEditDto.addTimeTeams = members;
        addAwayTimeCreateOrEditDto.awayTimeType = selectedAwayTimeType;
        addAwayTimeCreateOrEditDto.addTimeStatus = AddTimeStatus.Pending;
        addAwayTimeCreateOrEditDto.leaveTypeInfo = leaveType;
        addAwayTimeCreateOrEditDto.dayTypeInfo = dayType;

        return this.addAwayTimeServiceProxy.createOrEdit(addAwayTimeCreateOrEditDto);
    }

    updateTimeOff(id: number, statusString: string, userId: number) {
        return this.addAwayTimeServiceProxy.updateRequestStatus(id, statusString, 0, userId, 1, undefined);
    }

    getAwayTimeType(typeId: number) {
        return AwayTimeType[typeId]?.toString().replace(/([A-Z])/g, ' $1').trim();
    }
    getLeaveType(id: number) {
        return LeaveType[id]?.toString().replace(/([A-Z])/g, ' $1').trim();
    }
    getHalfDayType(id: number) {
        return DayType[id]?.toString().replace(/([A-Z])/g, ' $1').trim();
    }

    getAwayTimeStatus(statusId: number) {
        return AddTimeStatus[statusId]?.toString().replace(/([A-Z])/g, ' $1').trim();
    }

    getFormattedDate(dateString: string | DateTime) {

        const date = new Date(dateString.toString())
        return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()} ${this.monthNames[date.getMonth()]} ${date.getFullYear()}`;
    }

    getMonthName(dateString: string) {
        const date = new Date(dateString.toString().split('T')[0]);
        return `${this.monthNames[date.getMonth()]}`;
    }

    getDayDiff(fromDateString: string, toDateString: string) {
        return ((new Date(toDateString.toString().split('T')[0]).getTime() - new Date(fromDateString.toString().split('T')[0]).getTime()) / 86400000) + 1;
    }

    getTeamMembers(projectId: number) {
        return this.userServiceProxy.getProjectUnderUserList(projectId, false,this._abpSession.userId);
    }

    getDaysInBetween(fromDate: Date, toDate: Date) {
        let weekdayCount = 0;
        while (toDate.getTime() >= fromDate.getTime()) {
            weekdayCount++;
            fromDate = new Date(fromDate.getTime() + 86400000);
            fromDate.setHours(0, 0, 0, 0);
        }
        return weekdayCount;
    }

    getWeekdaysInBetween(fromDate: Date, toDate: Date) {
        let weekdayCount = 0;
        while (toDate.getTime() >= fromDate.getTime()) {
            if (fromDate.getDay() > 0 && fromDate.getDay() < 6) {
                weekdayCount++;
            }
            fromDate = new Date(fromDate.getTime() + 86400000);
            fromDate.setHours(0, 0, 0, 0);
        }
        return weekdayCount;
    }

    getDateWithZeroHours(dateString: string): Date {
        let date = new Date(dateString);
        date.setHours(0, 0, 0, 0);
        return date;
    }

    createTaskOffCommentService(input: string, userid: number | undefined | null, TenantId: number | undefined | null,
        TimeoffId: number | undefined | null) {

        const InputComment = new AddTimeOffCommentsDto();
        InputComment.comments = input;
        InputComment.userId = userid;
        InputComment.tenantId = TenantId;
        InputComment.timeOffId = TimeoffId;
        return this.addAwayTimeServiceProxy.createTimeOffComments(InputComment);
    }

    GetTimeOffComments(id: number) {

        return this.addAwayTimeServiceProxy.getTimeOffComments(id);
    }

    getLeaveTypeTextAndWeekdays(startDate: Date, endDate: Date, leaveId: number): string {
        
        if (leaveId === 1) {
          return '0.5 Day';
        } else {
          let weekdayCount = this.getWeekdaysInBetween(startDate, endDate);
          if (weekdayCount === 0){
            weekdayCount = 1;
          }
          return `${weekdayCount} ${weekdayCount === 1 ? 'Day' : 'Days'}`;
        }
      }
}
